export default {
      id: "member-fill-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#member-fill",
      toString: function () {
        return this.url;
      }
    }